import { useEffect } from 'react';

export const useOutsideAlerter = (ref, func) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        ref.current &&
        !ref.current.contains(event.target) &&
        event.target.className !== 'quick-view-btn btn add_assembly' &&
        event.target.className !== 'pl-3'
      ) {
        func(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line
  }, [ref]);
};
